import React from "react";
import PropTypes from "prop-types";
import useLanguageChange from "../../hooks/useLanguageChange";
import { useSelector } from "react-redux";
import UploadFileMarkupService from "../../services/UploadFileMarkupService/UploadFileMarkupService";
import { MARKUP_MENU_TYPE } from "../../constants/MarkupConstants";
import markupService from "../../services/MarkupService/markupService";

const ClearButton = ({ fromMarkup }) => {
    const localisedValues = useLanguageChange();
    const { annPointlength, clearMarkup } = useSelector((state) => state.markup);

    const clearMarkupHandler = () => {
        markupService.clearImg(true); // true - means clear all clicked and send notification to other users
    };

    return (
        <div className='markup-menu-item right-border mob-markup-menu-item markup-menu-item-clear' data-testid='markup-edit-menu-bar'>
            <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                <button
                    className='btn markup-menu-btn'
                    onClick={() => {
                        fromMarkup === MARKUP_MENU_TYPE.MARKUP_ANNOTATION ? clearMarkupHandler() : UploadFileMarkupService.clearMarkupOnFile();
                    }}
                    disabled={fromMarkup === MARKUP_MENU_TYPE.MARKUP_ANNOTATION ? !annPointlength : !clearMarkup}
                    data-testid='markup-edit-menu-button'
                >
                    <span className='btn-icon icon-clear'></span>
                    <span className='moremenu-text'>{localisedValues?.clear_all}</span>
                    <span className='mob-btn-text'>{localisedValues?.clear_all}</span>
                </button>
                <div className='custom-tooltip-content text-nowrap'>
                    <div className='custom-tooltip-in'>
                        <p>{localisedValues?.clear_all}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

ClearButton.propTypes = {
    fromMarkup: PropTypes.string,
};

export default ClearButton;
